import React, { Component } from "react";

import "css/FormWrapper.css";

class FormWrapper extends Component {
    render() {
        return (
            <div className={"FormWrapper " + (this.props.className || "")}>
                {
                    // stuff
                    this.props.children
                }
            </div>
        );
    }
}

export default FormWrapper;



// WEBPACK FOOTER //
// ./src/containers/FormWrapper.js